(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('TableauMedecineCtrl', TableauMedecineCtrl);

    TableauMedecineCtrl.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService'];

    function TableauMedecineCtrl ($scope, $state, ParseLinks, AlertService) {
        var vm = this;
    }
})();
